export const MAINBOARDV2API = "MainboardV2API";
export const NISSAN_CDR_API = "nissan_CDR_API";
export const USER_ACTIONS_API = "user_actions_API";
export const CDR_PROD = "CDR_Prod";
export const FRDS_VMS_FR_PROCESS_MANAGEMENT_API = "frds_vms_fr_process_management_API";
export const NISSAN_LEADS_API = "Nissan_Leads_API";
export const ECOM_CORE_KEYSTORE_API = "ecom_core_keystore_API";
export const ECOM_DEALER_ADMIN_API = "ecom_dealer_admin_API";
export const INVENTORY_LATEST_STOCKFILE_API = "inventory-latest-stockfile-api";
export const FORMULAE_CORE_API = "formulae_core_API";
export const STORYBLOK_ASSETS_API = "storyblok-assets-api";
